import React, { useMemo, useState } from 'react';
import { buildLeadActivitySummary } from '../utils/activitySummary';

export default function HandoffLeadModal({ lead, authUsers = [], currentUser, onClose, onSubmit }) {
  const [targetId, setTargetId] = useState('');
  const [message, setMessage] = useState('');
  const [includeSummary, setIncludeSummary] = useState(true);

  const candidates = authUsers.filter(u => u.id !== currentUser?.id);

  const activitySummary = useMemo(
    () => (lead?.id ? buildLeadActivitySummary(lead.id, 10) : []),
    [lead?.id],
  );

  if (!lead) return null;

  function handleSubmit() {
    if (!targetId || !message.trim()) return;
    onSubmit?.({
      targetUserId: targetId,
      message: message.trim(),
      includeSummary,
    });
  }

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 5000, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div style={{ width: 520, maxWidth: '100%', maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', background: 'var(--bg2)', borderRadius: 14, border: '1px solid var(--border)' }}>
        <div style={{ padding: '20px 22px 12px' }}>
          <div style={{ fontSize: 17, fontWeight: 800 }}>Lead übergeben</div>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4, marginBottom: 14 }}>{lead.name} · {lead.company}</div>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', marginBottom: 6 }}>Neuer Owner *</div>
          <select required value={targetId} onChange={e => setTargetId(e.target.value)} style={{ width: '100%', height: 40, borderRadius: 8, border: '1px solid var(--border)', marginBottom: 12, background: 'var(--bg3)', color: 'var(--text)' }}>
            <option value="">— Bitte wählen —</option>
            {candidates.map(u => (
              <option key={u.id} value={u.id}>{u.name || u.email}</option>
            ))}
          </select>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', marginBottom: 6 }}>Kontext für Kolleg:in *</div>
          <textarea value={message} onChange={e => setMessage(e.target.value)} rows={3} placeholder="Pflicht: Was ist der Stand? Nächster Schritt?"
            style={{ width: '100%', borderRadius: 8, border: '1px solid var(--border)', padding: 10, fontSize: 13, resize: 'vertical', background: 'var(--bg3)', color: 'var(--text)', boxSizing: 'border-box' }} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, fontSize: 12, color: 'var(--text2)', cursor: 'pointer' }}>
            <input type="checkbox" checked={includeSummary} onChange={e => setIncludeSummary(e.target.checked)} />
            Aktivitäts-Verlauf anhängen ({activitySummary.length} Einträge)
          </label>
          <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 8, padding: '8px 10px', background: 'rgba(29,190,116,0.08)', borderRadius: 8, border: '1px solid rgba(29,190,116,0.2)' }}>
            Es wird automatisch eine Aufgabe erstellt: <strong>„Bitte innerhalb von 24h anrufen“</strong>
          </div>
        </div>

        {includeSummary && activitySummary.length > 0 && (
          <div style={{ flex: 1, overflowY: 'auto', padding: '0 22px 12px', borderTop: '1px solid var(--border)', marginTop: 4 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', paddingTop: 12, marginBottom: 8 }}>Vorschau Verlauf</div>
            <div style={{ fontSize: 11, color: 'var(--text2)', lineHeight: 1.5, fontFamily: 'var(--mono)', whiteSpace: 'pre-wrap' }}>
              {activitySummary.join('\n')}
            </div>
          </div>
        )}

        <div style={{ padding: '12px 22px 18px', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button type="button" onClick={onClose} style={{ height: 38, padding: '0 14px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg3)', cursor: 'pointer' }}>Abbrechen</button>
          <button type="button" disabled={!targetId || !message.trim()} onClick={handleSubmit}
            style={{ height: 38, padding: '0 14px', borderRadius: 8, border: 'none', background: !targetId || !message.trim() ? 'var(--bg4)' : 'var(--accent)', color: '#fff', fontWeight: 600, cursor: !targetId || !message.trim() ? 'default' : 'pointer' }}>
            Übergeben
          </button>
        </div>
      </div>
    </div>
  );
}
